import EmptyState from 'components/EmptyState/EmptyState';
import ScheduleWeekList from 'components/schedule/createMission/ScheduleWeekList';

const ScheduleWeeksSection = ({
  scheduleWeeks,
  scheduleWeekDisplay,
  setScheduleWeekDisplay,
  isScheduleChecked,
  isScheduleRequired,
}) => {
  if (!isScheduleChecked || !scheduleWeeks?.length) {
    return (
      <EmptyState
        type={isScheduleRequired ? 'schedule_missing_periods' : 'schedule'}
      />
    );
  }

  return (
    <div>
      {scheduleWeeks.map((scheduleWeek, index) => (
        <ScheduleWeekList
          key={scheduleWeek.name ?? index}
          indexScheduleWeek={index}
          scheduleWeek={scheduleWeek}
          isPrevious={Boolean(scheduleWeeks[index - 1])}
          isNext={Boolean(scheduleWeeks[index + 1])}
          isHidden={scheduleWeekDisplay !== index}
          setScheduleWeekDisplay={setScheduleWeekDisplay}
        />
      ))}
    </div>
  );
};

export default ScheduleWeeksSection;
